import { render } from "./DisabledCard.vue?vue&type=template&id=3bcbd7cc&scoped=true"
const script = {}

import "./DisabledCard.vue?vue&type=style&index=0&id=3bcbd7cc&scoped=true&lang=less"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bcbd7cc"]])

export default __exports__